import { Component, EventEmitter, Output, Input } from '@angular/core';
import {Common} from '../../shared/common';

@Component({
  selector: 'confirm-suspend-popup',
  templateUrl: './confirm-suspend-popup.component.html',
  styleUrls: ['./confirm-suspend-popup.component.less', '../../shared/common.less']
})
export class ConfirmSuspendPopupComponent {
  @Output() isClosed = new EventEmitter<boolean>();
  @Input() isResend = true;
  @Input() isAssessors = false;
  @Input() assessors = []
  @Input() title = "";
  @Input() votersCount = 0;
  @Input() startDate
  @Input() endDate

  constructor(public common: Common) {}

  onDismiss(event: boolean) {
    this.isClosed.emit(event);
  }

}
